export class ProductProposalChangedError extends Error {
    constructor() {
        super();

        this.message = 'The product proposal has changed';
        this.name = 'ProductProposalChangedError';
    }
}
